module.exports = __webpack_public_path__ + "assets/img/qqzhcl-0.b8b458e9.jpg";